module.exports = __webpack_public_path__ + "img/btn-grey_search.a4920eb3.jpg";